







































import { Component, Prop, Mixins } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import { Customer } from '@/services/connecteur'
import customerModule from '@/store/modules/CustomerModule'

@Component({
  components: {}
})
export default class CustomerForm extends Mixins(BaseVue) {
  @Prop({ required: true })
  public customer!: Customer

  public closeModal () {
    this.$emit('close')
  }

  public async updateCustomer () {
    try {
      await customerModule.updateCustomer(this.customer)
      this.displayMessage(this.$t('customer.updated'))
      this.closeModal()
    } catch (error) {
      this.displayError(error)
    }
  }
}
